import {clearGlobalError, showGageError, showGlobalError} from "modules/actions";
import {createReducer} from "redux-act";

interface IErrorReducer {
	message?: string;
	gameError?: string;
}

export const error = createReducer<IErrorReducer>({}, {})
	.on(showGlobalError, (state, {message}) => ({...state, message}))
	.on(showGageError, (state, payload) => ({...state, gameError: payload}))
	.on(clearGlobalError, () => ({}));
